import React, { createContext, useState, useCallback } from 'react';
import { createContextHook } from '../contextUtils';

const ModalContext = createContext();

export function ModalProvider({ children }) {
  // Controls visibility of the main modal
  const [isModal, setIsModal] = useState(false);
  // Controls visibility of the filter editing modal
  const [editFilterOpen, setEditFilterOpen] = useState(false);
  // Controls visibility of the notes/information popover
  const [notePopoverOpen, setNotePopOverOpen] = useState(false);
  // Controls visibility of the share functionality modal
  const [shareModal, setShareModal] = useState(false);
  // Controls visibility of the general purpose popover
  const [popoverOpen, setPopOverOpen] = useState(false);
  // Controls visibility of the chart comparison modal
  const [compareModalOpen, setCompareModalOpen] = useState(false);

  const toggleModal = useCallback((modalSetter) => {
    modalSetter(prev => !prev);
  }, []);

  const value = {
    isModal, setIsModal,
    editFilterOpen, setEditFilterOpen,
    notePopoverOpen, setNotePopOverOpen,
    shareModal, setShareModal,
    compareModalOpen, setCompareModalOpen,
    popoverOpen, setPopOverOpen,
    toggleModal
  };

  return (
    <ModalContext.Provider value={value}>
      {children}
    </ModalContext.Provider>
  );
}

export const useModal = createContextHook(ModalContext, 'useModal');